import { Link, useLocation } from "react-router-dom";
import { Home, Search, ShoppingCart, User, Package } from "lucide-react";
import { useCart } from "../contexts/CartContext";

export const MobileBottomNav = () => {
  const location = useLocation();
  const { cartCount } = useCart();
  
  // Don't show on admin pages
  if (location.pathname.startsWith("/admin")) return null;

  const isActive = (path) => location.pathname === path;

  const navItems = [
    { path: "/", icon: Home, label: "Home" },
    { path: "/search", icon: Search, label: "Search" },
    { path: "/track", icon: Package, label: "Track" },
    { path: "/account", icon: User, label: "Account" },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-[#0A0A0A] lg:hidden" data-testid="mobile-bottom-nav">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`flex flex-col items-center justify-center gap-0.5 flex-1 h-full transition-colors ${
              isActive(item.path)
                ? "text-[#FF6B00]"
                : "text-gray-400 active:text-[#FF6B00]"
            }`}
          >
            <item.icon className="w-6 h-6" strokeWidth={isActive(item.path) ? 2.5 : 1.5} />
            <span className="text-[10px] font-bold">{item.label}</span>
          </Link>
        ))}
        {/* Cart with badge */}
        <Link
          to="/checkout"
          className={`flex flex-col items-center justify-center gap-0.5 flex-1 h-full relative transition-colors ${
            isActive("/checkout") ? "text-[#FF6B00]" : "text-gray-400 active:text-[#FF6B00]"
          }`}
        >
          <div className="relative">
            <ShoppingCart className="w-6 h-6" strokeWidth={isActive("/checkout") ? 2.5 : 1.5} />
            {cartCount > 0 && (
              <span className="absolute -top-2 -right-3 bg-[#FF6B00] text-white text-[10px] font-bold min-w-[18px] h-[18px] flex items-center justify-center rounded-full">
                {cartCount}
              </span>
            )}
          </div>
          <span className="text-[10px] font-bold">Cart</span>
        </Link>
      </div>
    </nav>
  );
};
